/* NovaraLabs: even review cards + read-more (2026-09-10) */
(function(){
  function init(){
    var texts=document.querySelectorAll('.reviews-transformation-section .review-text');
    texts.forEach(function(t){
      if(t.dataset.nvDone) return; t.dataset.nvDone='1';
      var lh=parseFloat(getComputedStyle(t).lineHeight)||20; var maxH=lh*8+2;
      if(t.scrollHeight<=maxH+4) return;
      t.classList.add('nv-clamp');
      var b=document.createElement('button'); b.type='button'; b.className='nv-readmore'; b.textContent='Read more';
      b.addEventListener('click',function(e){e.preventDefault(); e.stopPropagation(); var open=t.classList.toggle('nv-clamp'); b.textContent=open?'Read more':'Read less';});
      t.parentNode.insertBefore(b,t.nextSibling);
    });
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init); else init();
  setTimeout(init,1500); setTimeout(init,4000);
})();
